<template>
  <div class="l-modal-wrapper">
    <div :class="classObject">
      <slot/>

      <svg v-if="isClose === 'true'" @click="$emit('modal-close')" class="l-modal__close" width="38px" height="38px" viewBox="0 0 38 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill-rule="evenodd">
              <g transform="translate(0.000000, -1.000000)" fill-rule="nonzero">
                  <path d="M34.526,38.354 L18.971,22.798 L3.415,38.354 C3.03990398,38.729248 2.53107337,38.9400729 2.0005,38.9400729 C1.46992663,38.9400729 0.961096021,38.729248 0.586,38.354 C-0.194763877,37.5730003 -0.194763877,36.3069997 0.586,35.526 L16.142,19.969 L0.586,4.413 C0.210751987,4.03790398 -7.29332814e-05,3.52907337 -7.29332814e-05,2.9985 C-7.29332814e-05,2.46792663 0.210751987,1.95909602 0.586,1.584 C0.961096021,1.20875199 1.46992663,0.997927067 2.0005,0.997927067 C2.53107337,0.997927067 3.03990398,1.20875199 3.415,1.584 L18.971,17.141 L34.527,1.585 C34.902096,1.20975199 35.4109266,0.998927067 35.9415,0.998927067 C36.4720734,0.998927067 36.980904,1.20975199 37.356,1.585 C37.731248,1.96009602 37.9420729,2.46892663 37.9420729,2.9995 C37.9420729,3.53007337 37.731248,4.03890398 37.356,4.414 L21.799,19.971 L37.355,35.528 C38.1357639,36.3089997 38.1357639,37.5750003 37.355,38.356 C36.9803894,38.7316592 36.4715211,38.942548 35.941,38.942 C35.4098442,38.9422848 34.9005261,38.7306388 34.526,38.354 L34.526,38.354 Z"></path>
              </g>
          </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isClose', 'modalType'],

  data () {
    return {
      active: true
    }
  },

  computed: {
    classObject () {
      let name

      if (this.modalType) {
        name = 'l-modal l-modal--' + this.modalType
      } else {
        name = 'l-modal l-modal--default'
      }

      return name
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue